<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <div class="block">
        <span class="demonstration" style="margin-right:20px;">时间筛选</span>
        <el-date-picker
          v-model="value1"
          type="datetime"
          style="margin-right:20px;"
          placeholder="选择开始时间"
        >
        </el-date-picker>
        <el-date-picker
          v-model="value2"
          type="datetime"
          placeholder="选择结束时间"
        >
        </el-date-picker>
      </div>

      <a-form
        layout="inline"
        @keyup.enter.native="searchQuery"
        style="margin-top:20px;"
      >
        <a-row :gutter="24">
          <a-col :md="6" :sm="8">
            <span
              style="float: left;overflow: hidden;"
              class="table-page-search-submitButtons"
            >
              <a-button type="primary" @click="searchQuery" icon="search"
                >查询</a-button
              >
              <a-button
                type="primary"
                @click="searchReset"
                icon="reload"
                style="margin-left: 8px"
                >重置</a-button
              >
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- table -->
    <div>
      <a-table
        :columns="columns"
        bordered
        :dataSource="dataSource"
        :rowKey="r => r.userId"
      >
        <a slot="name" slot-scope="text">{{ text }}</a>
      </a-table>
    </div>
  </a-card>
</template>

<script>
import { JeecgListMixin } from '@/mixins/JeecgListMixin';

export default {
  name: 'fontmanage',
  mixins: [JeecgListMixin],
  components: {},
  data() {
    return {
      description: '这是字库管理页面',
      queryParam: {},
      recycleBinVisible: false,
      value1: '',
      value2: '',
      columns: [
        {
          title: '日志时间',
          dataIndex: 'isLeader',
          align: 'center'
        },
        {
          title: '终端设备',
          dataIndex: 'gender',
          width: 100,
          align: 'center'
        },
        {
          title: '类型',
          dataIndex: 'mainDepartment',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '操作人',
          dataIndex: 'name',
          key: 'name',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '过滤字段',
          dataIndex: 'qrCode',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '警告次数',
          dataIndex: 'enable',
          ellipsis: true,
          align: 'center'
        }
      ],
      url: {
        list: process.env.VUE_APP_CMS_WECHATWORK + '/wechatwork/market/data'
      }
    };
  },
  computed: {
    importExcelUrl: function() {
      return `${process.env.GATEWAY + process.env.VUE_APP_CMS_SYSTEM}/${
        this.url.importExcelUrl
      }`;
    }
  },
  methods: {}
};
</script>
<style scoped>
@import '~@assets/less/common.less';
</style>
